import requestAction from '../utils/requestAction'

export const fetchProposals = () =>
  requestAction('PROPOSAL_LIST')('proposals', 'GET')
